import React, { useContext, useState } from 'react'
import PatientAccountService from '../../../../../services/api/patient-account.service'
import PatientAccountForm from '../patient-account-form/PatientAccountForm'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'
import { store } from '../../../../../context/StateProvider'
const PatientAccountAdd = (props) => {
    // context state and dispatch 
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const [apiResponse, setApiResponse] = useState()
    const [isSubmitted, setIsSubmitted] = useState(false)
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const submitHandler = (type, data) => {
        setIsSubmitted(true)
        let reqObj = {
            "address": {
                "addressLine1": data.address.addressLine1 || null,
                "addressLine2": data.address?.addressLine2 || null,
                "city": data.address.city || null,
                "state": data.address.state || null,
                "country": data.address.state ? 1 : null,
                "postalCode": data.address.postalCode ? data.address.postalCode.toString() : null
            },
            "samePatientAddress": data.samePatientAddress === 1 ? true : false || false,
            "accountHolderName": data.accountHolderName,
            "isActive": true,
            "practiceLocationId": data.practiceLocationId
        }
        if (type === "credit-debit") {
            reqObj = {
                ...reqObj,
                "cardNumber": data?.cardNumber?.toString().replace(" ", "").replace(" ", "").replace(" ", "")?.replace("_", ""),
                "cardExpiry": data?.cardExpiry?.toString().replace("/", ""),
                "cardType": data.cardType,
                "accountType": 1
            }
        }
        else if (type === "ach") {
            reqObj = {
                ...reqObj,
                "accountNumber": data.accountNumber,
                "bankName": data.bankName,
                "isCheckingAccount": Boolean(data.isCheckingAccount),
                "routingNumber": data.routingNumber,
                "accountType": 2
            }
        }
        PatientAccountService.addPatientAccount(props.patientId, reqObj)
            .then(res => {
                setApiResponse(res)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsSubmitted(false)
            })
    }
    return (
        <>
            {isSubmitted ? <DimLoader loadMessage="Adding Account..." /> : null}
            <PatientAccountForm initialData={{ address: {}, patientId: props.patientId, practiceLocationId: props.practiceLocationId || state.practiceLocationId }} onClose={() => props.onClose()} buttonLabel="Add" disableLocationEdit={props.disableLocationEdit} submitHandler={submitHandler} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>

    )
}

export default PatientAccountAdd